import React, { useContext, useEffect, useRef, useState } from 'react';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import { GlobalStateContext } from '../../components/general/GlobalStateProvider';
import { useNavigate } from 'react-router-dom';
import DataOps from '../../data/DataOps';
import { toast } from 'react-toastify';

const HostingMain = () => {
    const [isResolving, setIsResolving] = useState(true);
    const hasResolvedRef = useRef(false);
    const { user: user, isLoadingUser, setShowLoginModal } = useContext(GlobalStateContext);
    const isHostAccount = user?.accountType === 'host';
    const navigation = useNavigate();

    useEffect(() => {
        const resolveHostDestination = async () => {
            if (isLoadingUser || hasResolvedRef.current) return;

            hasResolvedRef.current = true;

            if (!user) {
                setShowLoginModal(true);
                setIsResolving(false);
                return;
            }

            if (!isHostAccount) {
                toast.error('Only host accounts can manage camp listings.');
                navigation('/account', { replace: true });
                setIsResolving(false);
                return;
            }

            try {
                const collection = DataOps.getCollectionNameForAccountType(user.accountType);
                const userData = await DataOps.fetchDataFromFirebase(collection, user.userId);
                const campIds = (userData && Array.isArray(userData.camps)) ? userData.camps : [];

                if (campIds.length > 0) {
                    navigation('/camps/' + campIds[0], { replace: true });
                } else {
                    navigation('/hosting-create-camp/setup', { replace: true });
                }
            } catch (error) {
                toast.error('Error fetching camp data');
                setIsResolving(false);
            }
        };

        resolveHostDestination();
    }, [isLoadingUser, isHostAccount, navigation, setShowLoginModal, user]);

    return (
        <View style={styles.container}>
            <ActivityIndicator size="large" color="#3C8248" />
            <Text style={styles.statusText}>
                {isResolving ? 'Loading your host workspace...' : 'Redirecting...'}
            </Text>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: 24,
    },
    statusText: {
        marginTop: 12,
        fontSize: 14,
        color: '#666',
        fontWeight: '500',
    },
});

export default HostingMain;